module.exports = __webpack_public_path__ + "img/Element12_Fehler_Ziffernrechnen.3290f6da.png";